export default {
	title: '月度报告配置',
	actions: {
		add: '新增',
		edit: '修改',
		delete: '删除',
		batchDelete: '批量删除',
		save: '保存',
		cancel: '取消',
		confirm: '确定'
	},
	messages: {
		deleteSuccess: '删除成功',
		actionSuccess: '操作成功'
	},
	labels: {
		monthReportConfig: '月度报告配置'
	},
	buttons: {
		add: '新增',
		batchDelete: '批量删除',
		edit: '修改',
		delete: '删除'
	},
	table: {
		projectName: '项目名称',
		executionMode: '执行模式',
		action: '操作'
	},
	form: {
		placeholder: {
			projectName: '项目名称',
			executionMode: '执行模式'
		},
		selectProject: '请选择所属项目',
		selectExecutionMode: '请选择执行模式'
	},
	config: {
		gridLayout: '格栅布局',
		ownedProject: '所属项目',
		executionMode: '执行模式',
		day: '日',
		week: '周',
		month: '月'
	},
	dialog: {
		add: '新增',
		update: '修改'
	}
}
